module.exports = __webpack_public_path__ + "img/67ef1fd.png";